<template>
  <div id="app">
    <daqsNav />
    <div class="container">
      <router-view
        :key="$route.name"
        class="main-content"
      />
    </div>
    <waves />
    <daqsFooter />
  </div>
</template>
<script>
const daqsNav = () => import('@/components/daqsNav')
const daqsFooter = () => import('@/components/daqsFooter')
const waves = () => import('@/components/waves')
export default {
  name: 'App',
  components: { daqsNav, daqsFooter, waves },
  mounted () {
    this.$store.subscribeAction({
      before: (action, state) => {
        if (action.type.includes('FILTER')) {
          this.$store.commit('SET_LOADING', true)
        }
      },
      after: (action, state) => {
        if (action.type.includes('LOAD_DATA')) {
          this.$store.commit('SET_LOADING', false)
        }
      }
    })
  }
}
</script>
